import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { metersQueryKey } from '../queries/useMeters'
import type { MeterReading, MeterReadingWrite } from '../types'

export function useCreateMeterReading() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const onError = useOnError()

  async function createReading({
    meterId,
    body
  }: {
    meterId: string
    body: MeterReadingWrite
  }) {
    const response = await apiClient.post<MeterReading>(
      SNA_PREFIX + `meters/${meterId}/readings`,
      body
    )
    return response.data
  }

  return useMutation({
    mutationFn: createReading,
    onSuccess: () => {
      toast.success({ message: t('meterReadingCreated') })
      queryClient.invalidateQueries({ queryKey: metersQueryKey })
    },
    onError
  })
}
